module.exports = __webpack_public_path__ + "static/media/ram.1608e0f1.png";